export default __webpack_public_path__ + "static/media/pic12.51e39206.jpg";